import { Loader2 } from "lucide-react";

export function Button({ as: Tag = "button", variant = "primary", size = "md", className = "", children, loading, ...props }) {
  const variants = {
    primary: "bg-sky-500 text-white hover:bg-sky-600 shadow-sm shadow-sky-200",
    dark: "bg-slate-900 text-white hover:bg-slate-800",
    outline: "border border-slate-200 text-slate-700 hover:border-sky-300 hover:text-sky-600 bg-white",
    ghost: "text-slate-600 hover:bg-slate-100",
    danger: "bg-rose-500 text-white hover:bg-rose-600",
    soft: "bg-sky-50 text-sky-700 hover:bg-sky-100",
  };
  const sizes = { sm: "px-3 py-1.5 text-sm", md: "px-4 py-2.5 text-sm", lg: "px-6 py-3 text-base" };
  return (
    <Tag
      className={`inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading && <Loader2 className="w-4 h-4 animate-spin" />}
      {children}
    </Tag>
  );
}

export function Input({ className = "", ...props }) {
  return (
    <input
      className={`w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm text-slate-900 placeholder:text-slate-400 focus:border-sky-400 focus:ring-2 focus:ring-sky-100 outline-none transition ${className}`}
      {...props}
    />
  );
}

export function Card({ className = "", children, ...props }) {
  return <div className={`card-soft ${className}`} {...props}>{children}</div>;
}

export function Badge({ color = "sky", children, className = "", ...props }) {
  const colors = {
    sky: "bg-sky-50 text-sky-700 ring-sky-200",
    green: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    amber: "bg-amber-50 text-amber-700 ring-amber-200",
    red: "bg-rose-50 text-rose-700 ring-rose-200",
    slate: "bg-slate-100 text-slate-600 ring-slate-200",
    violet: "bg-violet-50 text-violet-700 ring-violet-200",
  };
  return (
    <span {...props} className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold ring-1 ring-inset ${colors[color]} ${className}`}>
      {children}
    </span>
  );
}

export function Spinner({ className = "" }) {
  return <Loader2 className={`animate-spin text-sky-500 ${className}`} />;
}

export const STATUS_COLORS = {
  new: "slate", contacted: "sky", replied: "violet",
  negotiating: "amber", closed: "green", lost: "red",
};
export const TAG_COLORS = { hot: "red", warm: "amber", cold: "sky", irrelevant: "slate" };
